var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "74px",
    viewBox: "0 0 81 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#00CC69",
    transform: "translate(40.883476, 10.000000) rotate(90.000000) translate(-40.883476, -10.000000) ",
    x: 30.8834755,
    y: -30,
    width: 20,
    height: 80,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9286792,1.95019231 C46.4515267,1.95019231 50.9286792,6.42734481 50.9286792,11.9501923 L50.9286792,61.9501923 C50.9286792,67.4730398 46.4515267,71.9501923 40.9286792,71.9501923 C35.4058317,71.9501923 30.9286792,67.4730398 30.9286792,61.9501923 L30.9286792,11.9501923 C30.9286792,6.42734481 35.4058317,1.95019231 40.9286792,1.95019231 Z",
    id: "Rectangle-Copy-21",
    fill: "#FEC10B",
    transform: "translate(40.928679, 36.950192) rotate(90.000000) translate(-40.928679, -36.950192) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00B0FF",
    transform: "translate(41.000000, 63.609762) rotate(90.000000) translate(-41.000000, -63.609762) ",
    x: 31,
    y: 23.6097624,
    width: 20,
    height: 80,
    rx: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.53377012becfc97a604f1356b6b23a65.svg";
export { ForwardRef as ReactComponent };